import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Reordering a waterfall. The order is the DOM order of the rows: the save
// button reads the .selectedProvider spans top to bottom, so there is nothing
// to persist here - dragging a row is the change, Save is what commits it.
//
// (The old drag controller PUT to an undefined url on every drop, which threw
// in the console and saved nothing.)
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-flow-order-handle]",
      animation: 130,
      ghostClass: "flow-row--ghost",
      onEnd: () => this.element.dispatchEvent(new CustomEvent("flow:reordered", { bubbles: true }))
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }
}
